import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface GridIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const ExclamationMarkErrorIcon = observer(
    'ExclamationMarkErrorIcon',
    ({ className, onClick }: GridIconPropsType): JSX.Element => {
        return (
            <SvgElement
                className={className}
                clipRule='evenodd'
                width='14'
                height='14'
                viewBox='0 0 14 14'
                fill='none'
                onClick={onClick}
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M7.00004 10.3333C7.18893 10.3333 7.34726 10.2694 7.47504 10.1417C7.60282 10.0139 7.66671 9.85555 7.66671 9.66666C7.66671 9.47777 7.60282 9.31944 7.47504 9.19166C7.34726 9.06388 7.18893 9 7.00004 9C6.81115 9 6.65282 9.06388 6.52504 9.19166C6.39726 9.31944 6.33337 9.47777 6.33337 9.66666C6.33337 9.85555 6.39726 10.0139 6.52504 10.1417C6.65282 10.2694 6.81115 10.3333 7.00004 10.3333ZM6.33337 7.66666H7.66671V3.66666H6.33337V7.66666ZM7.00004 13.6667C6.07782 13.6667 5.21115 13.4917 4.40004 13.1417C3.58893 12.7917 2.88337 12.3167 2.28337 11.7167C1.68337 11.1167 1.20837 10.4111 0.858374 9.6C0.508374 8.78888 0.333374 7.92222 0.333374 7C0.333374 6.07777 0.508374 5.21111 0.858374 4.39999C1.20837 3.58888 1.68337 2.88333 2.28337 2.28333C2.88337 1.68333 3.58893 1.20833 4.40004 0.858328C5.21115 0.508328 6.07782 0.333328 7.00004 0.333328C7.92226 0.333328 8.78893 0.508328 9.60004 0.858328C10.4112 1.20833 11.1167 1.68333 11.7167 2.28333C12.3167 2.88333 12.7917 3.58888 13.1417 4.39999C13.4917 5.21111 13.6667 6.07777 13.6667 7C13.6667 7.92222 13.4917 8.78888 13.1417 9.6C12.7917 10.4111 12.3167 11.1167 11.7167 11.7167C11.1167 12.3167 10.4112 12.7917 9.60004 13.1417C8.78893 13.4917 7.92226 13.6667 7.00004 13.6667Z'
                    fill='fill'
                />
            </SvgElement>
        );
    }
);
